import { Col } from 'antd'
import React, { useMemo } from 'react'
import styles from './HandHeader.module.scss'
import { CardImage } from '../../../components/cards/CardImage'
import { PositionCard } from '../../Report/PositionCard'
import { toFixed } from '../../../helpers/helpers'

// generate view result
function HandHeader({ handTab, handData, isHideOOPHand, filter, isTopBar }) {
	const { players, positions, hands, stacks, isHero, win: result, summary_players: summaryPlayers } = handData
	const isHeroIdx = useMemo(() => {
		if (['hands'].includes(handTab)) {
			return isHero.indexOf(true)
		}

		return isHero.indexOf(filter.is_hero)
	}, [handTab, filter.is_hero])
	const header = []

	for (let i = 0; i < players.length; i++) {
		const c1 = hands[i].substring(0, 2)
		const c2 = hands[i].substring(2, 4)
		const win = result[i].toString().indexOf('-') === 0 ? result[i].toFixed(2) : `+${result[i].toFixed(2)}`
		const diff_ev = summaryPlayers[i].is_ev_exist ? summaryPlayers[i].diff_ev.toFixed(2) : null
		const diff_played = summaryPlayers[i].is_ev_exist ? toFixed(summaryPlayers[i].diff_played * 100, 2) : null

		const renderHeaderForFewPlayers = () => {
			const cardImages = [c1, c2]

			return (
				<div className={styles.headerForFewPlayers}>
					<div className={styles.diffContainerForFewPlayers}>
						{diff_ev !== null && <span>ΔEV {diff_ev}</span>}
						{diff_played && <span className={styles.diffPlayedForFewPlayers}>Δ% {diff_played}%</span>}
					</div>

					<Col xl={12} className={styles.playerHeaderContainer}>
						<div className={styles.cardImageContainer}>
							{cardImages.map((c, index) => (
								<CardImage
									key={index}
									isSmall
									// card={c}
									card={isHideOOPHand && i !== isHeroIdx ? '-' : c}
									isInstaHand
								/>
							))}
						</div>

						<div className={[styles.textHeaderContainer, styles.textHeaderContainerByFewPlayer].join(' ')}>
							<div className={styles.playerHeaderPlayer}>
								<PositionCard position={positions[i]} />
								<span className={styles.stacks}>{stacks[i]}</span>
							</div>

							<div className={styles.playersContainer}>
								<div className={styles.playerContainer}>
									<span>{players[i]}</span>
								</div>

								<span
									className={[
										styles.playerHeaderStackWin,
										result[i].toString().indexOf('-') === 0 ? styles.winNeg : styles.winPos,
									].join(' ')}
								>
									{isTopBar ? `${win}bb` : filter && filter.source === 'upload' && `${win}bb`}
								</span>
							</div>
						</div>
					</Col>
				</div>
			)
		}

		const renderHeaderForTwoPlayers = () => {
			const cardImages = [c1, c2]

			return (
				<div className={[styles.playerHeaderContainer, styles.headerForTwoPlayersContainer].join(' ')}>
					<div>
						{cardImages.map((c, index) => (
							<CardImage key={index} isSmall card={isHideOOPHand && positions[i] !== positions[isHeroIdx] ? '-' : c} />
						))}
					</div>

					<div className={styles.textHeaderContainer}>
						<div className={styles.playerHeaderPlayer}>
							<PositionCard position={positions[i]} />
							<span className={styles.playersContainer}>{players[i]}</span>
						</div>

						<div className={styles.playerHeaderStack}>
							<span>{stacks[i]}</span>

							<span
								className={[
									styles.playerHeaderStackWin,
									result[i].toString().indexOf('-') === 0 ? styles.winNeg : styles.winPos,
								].join(' ')}
							>
								{isTopBar ? `${win}bb` : filter && filter.source === 'upload' && `${win}bb`}
							</span>

							{/* Display diff_ev and diff_played for two players*/}
							<div className={styles.diffContainerForTwoPlayers}>
								{diff_ev !== null && <span>ΔEV {diff_ev}</span>}

								{diff_played && <span>Δ% {diff_played}%</span>}
							</div>
						</div>
					</div>
				</div>
			)
		}
		header.push(<>{players.length > 2 ? renderHeaderForFewPlayers() : renderHeaderForTwoPlayers()}</>)
	}

	return <div className={styles.headersContainer}>{header}</div>
}

export default HandHeader
